var map = {
	"./Image assign 3.png": 71,
	"./batch_img.jpg": 3628,
	"./batch_img_eg.png": 2273,
	"./blog_profile_face.png": 9142,
	"./blog_profile_link.png": 5273,
	"./blog_profile_twit.png": 1969,
	"./certificate_img.png": 7917,
	"./csvfile.png": 7310,
	"./csvicon.png": 3863,
	"./cvsicon.png": 4553,
	"./docsicon.png": 744,
	"./edit-pencil-img.png": 9420,
	"./email_chat_user.png": 3285,
	"./excelicon.png": 1246,
	"./fileicon.png": 4615,
	"./folder-open.png": 1989,
	"./forder-img.png": 4862,
	"./giffile.png": 7728,
	"./gsheeticon.png": 8085,
	"./icons8-excel-32.png": 2490,
	"./icons8-facebook-32.png": 7033,
	"./icons8-instagram-32.png": 4961,
	"./icons8-linkedin-2-32.png": 8688,
	"./icons8-linkedin-32.png": 2691,
	"./icons8-x-32.png": 3541,
	"./img-avatar.png": 4659,
	"./ipynbfile.png": 2022,
	"./jpegfile.png": 4474,
	"./jsonfile.png": 5818,
	"./loginimg.png": 9970,
	"./mail_swap.png": 4593,
	"./module-pdf-img.png": 2593,
	"./module-video-img.png": 4938,
	"./module_placeholder.png": 5648,
	"./not_email.png": 2918,
	"./odticon.png": 1320,
	"./oeson-blue.png": 5727,
	"./oeson-learn-logo.png": 7017,
	"./pdficon.png": 1769,
	"./pngfile.png": 7679,
	"./pyfile.png": 1037,
	"./refer-arrow 1.svg": 859,
	"./resource_color.png": 6714,
	"./resource_fol.png": 364,
	"./resource_name.png": 5478,
	"./resource_refer.png": 4613,
	"./resource_trash.png": 1361,
	"./resourcenot.png": 6959,
	"./rtficon.png": 8803,
	"./student-report-img.png": 2476,
	"./txticon.png": 6659,
	"./undraw_studying_n5uj.png": 3898,
	"./video-placeholder.png": 4237,
	"./work-img.png": 4575,
	"./xlsfile (2).png": 3294,
	"./xlsfile.png": 1793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5687;